import { render, staticRenderFns } from "./MapBoxItemComponent.vue?vue&type=template&id=6eb671ff&scoped=true"
import script from "./MapBoxItemComponent.vue?vue&type=script&lang=js"
export * from "./MapBoxItemComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb671ff",
  null
  
)

export default component.exports